'use client'
import React, { useState } from 'react'
import dynamic from 'next/dynamic'
import Head from 'next/head'
// import pdf from '../../../../public/Pyther_IoT_Portfolio.pdf'
import ContactSection from '../../../app/_components/Section/Contact'
import ProductDetails from '../Section/ProductDetails'
import PageBanner from '../PageBanner'
import { Span } from 'slate'

const LatestProductSlider = dynamic(
  () => import('../../../app/_components/Sliders/LatestProduct'),
  { ssr: false },
)

const Portfolio: React.FC = () => {
  const [selectedProductIndex, setSelectedProductIndex] = useState<number | null>(null)
  return (
    <>
      <Head>
        <title>Portfolio - Pyther Innovation</title>
        {/* <link rel="canonical" href={`${process.env.NEXT_PUBLIC_SERVER_URL}/portfolio`} /> */}
      </Head>
      <PageBanner pageName={'Portfolio'} pageTitle={'Get the product you want'} />

      <LatestProductSlider setSelectedProductIndex={setSelectedProductIndex} />

      {/* Product Details section */}
      <ProductDetails selectedProductIndex={selectedProductIndex} />

      {/* adding a pdf file in Portfolio */}

      <section>
        <div className="container">
          <h1 className="mil-h2 text-left ms-3">
            Company Service
            <span className="ms-2 mil-h2 mil-accent">Profile</span>
          </h1>

          <div className="pdf-container mil-dig-text mil-h4">
            <a
              href="/pdf/iot-portfolio.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="pdf-frame"
            >
              <img src="/theme/iot2.jpg" alt="IoT portfolio Image" />

              <div className="d-flex align-items-center font-size-6 " style={{ color: '#0056b3' }}>
                <span>IoT Portfolio</span>
                {/* <i className="fa-solid fa-download ms-3"></i> */}
                <i
                  className=" fa-sharp fa-regular fa-circle-down  ms-1 ms-sm-2"
                  style={{ color: '#0056b3' }}
                ></i>
              </div>
            </a>

            <a
              href="/pdf/services-portfolio.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="pdf-frame"
            >
              <img src="/theme/service.jpg" alt="Services portfolio Image" />

              <div className="d-flex align-items-center font-size-6" style={{ color: '#0056b3' }}>
                <span>Services Portfolio</span>
                {/* <i className="fa-solid fa-download ms-3"></i> */}
                <i
                  className="fa-sharp fa-regular fa-circle-down  ms-1 ms-sm-2"
                  style={{ color: '#0056b3' }}
                ></i>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* products */}
      <section className="mil-p-0-10">
        <div className="container">
          <div className="mil-divider" />
          <p></p>
          <div className="col-lg-12">
            <div className="mil-h4" style={{ fontSize: '2rem' }}>
              <div style={{ marginBottom: '0' }}>Our Client - </div>
              <div style={{ marginBottom: '0' }}><span className="mil-accent">India, US, Canada, UK, Australia and more.. </span></div>
              <div style={{ marginBottom: '0' }}>Headquarter - India</div>
            </div>
          </div>
        </div>
      </section>

      {/* contact section */}
      <ContactSection />
    </>
  )
}

export default Portfolio
